import React from "react";
import { StyleSheet, View } from "react-native";
import color from "@constants/color";
import Text from "@components/CustomText";
interface PayoutInfo {
  title_1: string;
  value_1: number;
  title_2: string;
  value_2: number;
  title_3: string;
  value_3: number;
}

interface PayoutSubCardProps {
  extra_info: PayoutInfo[];
}
export const PayoutSubCard: React.FC<PayoutSubCardProps> = ({ extra_info }) => {
  return (
    <View style={styles.summaryContainer}>
      {extra_info?.map((item: any, index) => (
        <View style={styles.listItem} key={index}>
          <View style={[styles.itemContainer, { width: "40%" }]}>
            <Text
              variant="caption_2"
              style={styles.textstyle}
              numberOfLines={2}
            >
              {item.title1}
            </Text>
            <View style={styles.divider} />
            <Text variant="caption_2" style={styles.textstyle}>
              {item.value1}
            </Text>
          </View>
          <Text variant="caption_2" style={styles.mathSign}>
            x
          </Text>
          <View style={styles.itemContainer}>
            <Text
              variant="caption_2"
              style={styles.textstyle}
              numberOfLines={2}
            >
              {item.title2}
            </Text>
            <View style={styles.divider} />
            <Text variant="caption_2" style={styles.textstyle}>
              {item.value2}
            </Text>
          </View>
          <Text variant="caption_2" style={styles.mathSign}>
            =
          </Text>
          <View style={[styles.itemContainer, { width: "20%" }]}>
            <Text
              variant="caption_2"
              style={styles.textstyle}
              numberOfLines={2}
            >
              {item.title3}
            </Text>
            <View style={styles.divider} />
            <Text variant="caption_2" style={styles.textstyle}>
              {item.value3}
            </Text>
          </View>
        </View>
      ))}
    </View>
  );
};

export default PayoutSubCard;

const styles = StyleSheet.create({
  summaryContainer: {
    backgroundColor: color.white,
    borderRadius: 16,
  },
  listItem: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 8,
    borderRadius: 8,
    alignItems: "center",
    backgroundColor: "#F5F8FA",
    marginVertical: 4,
  },
  textstyle: {
    color: color.black06,
    lineHeight: 16,
    fontSize: 11,
  },
  itemContainer: {
    width: "30%",
    alignItems: "center",
    justifyContent: "space-evenly",
  },
  divider: {
    height: 1.5,
    backgroundColor: color.white,
    width: "100%",
    marginTop: 2,
    marginBottom: 4,
  },
  mathSign: {
    color: color.black06,
    marginBottom: 16,
  },
});
